import "./style.css";

export default class Input {
  static selector = ".s-input";

  constructor(block) {
    this.block = block;
    this.$input = block.querySelector("input");
  }

  onFocus() {
    this.block.classList.add("focus");
  }

  onBlur() {
    this.block.classList.remove("focus");
  }

  onEyeOnClick() {
    this.$eyeOff.classList.remove("hide");
    this.$eyeOn.classList.add("hide");
    this.$input.setAttribute("type", "text");
  }

  onEyeOffClick() {
    this.$eyeOff.classList.add("hide");
    this.$eyeOn.classList.remove("hide");
    this.$input.setAttribute("type", "password");
  }

  addPasswordListener() {
    this.$eyeOn = this.block.querySelector("svg.on");
    this.$eyeOff = this.block.querySelector("svg.off");

    this.$eyeOn.addEventListener("click", this.onEyeOnClick.bind(this));
    this.$eyeOff.addEventListener("click", this.onEyeOffClick.bind(this));
  }

  onReady() {
    this.$input.addEventListener("focus", this.onFocus.bind(this));
    this.$input.addEventListener("blur", this.onBlur.bind(this));

    if (this.block.classList.contains("s-input__eye")) {
      this.addPasswordListener();
    }
  }
}
